app.controller('KioskBookingController', ['$scope', 'dataShare', '$location', '$http', '$window', '$routeParams', '$translate', 'getServicesAndProducts', 'Backend', '$q', function ($scope, dataShare, $location, $http, $window, $routeParams, $translate, getServicesAndProducts, Backend, $q) {

    $scope.infoData = infoData;
    $scope.Language = infoData.Country;
    $scope.success = false;
    $scope.currentStep = 1;
    $scope.ready = false;

    $scope.booked = [];
    $scope.orderInfo = {};
    $scope.orderInfo.Time = '';
    $scope.orderInfo.Time = '';
    $scope.orderInfo.Discount = false;
    $scope.orderInfo.People = 0;
    $scope.orderInfo.ParentsAttending = 0;
    $scope.orderInfo.deposit = false;
    $scope.orderInfo.TotalPrice = 0;
    $scope.orderInfo.TotalPriceWT = 0;
    $scope.orderInfo.TotalPriceDisc = 0;
    $scope.orderInfo.TotalPriceDiscWT = 0;
    $scope.orderInfo.Comment = '';
    $scope.orderInfo.addonsSum = 0;
    $scope.orderInfo.addonsSumWT = 0;
    $scope.orderInfo.Schedules = [];
    $scope.orderInfo.GymID = params.GymID;
    $scope.orderInfo.NameSpace = params.NameSpace;
    $scope.orderInfo.KioskMode = true;
    $scope.terms = $scope.infoData.Settings.GeneralConditionsLink;
    $scope.isPaymentAvailable = false;
    $scope.Currency = infoData.Currency;
    $scope.CompanyName = infoData.CompanyName;
    $scope.ShowFullPrices = $scope.infoData.Settings.ShowFullPrices;

    $scope.orderInfo.Earnest = infoData.Settings.Earnest;
    $scope.orderInfo.OnlineBookingWhatToWear = '';

    $scope.orderInfo.Areas = [];
    $scope.orderInfo.Time = '';
    $scope.orderInfo.PriceWithoutTax = '';
    $scope.orderInfo.VisitName = '';
    $scope.showCart = false;
    $scope.showAddOn = false;

    var data = dataShare.getData();
    $scope.adds = data.addons;

    $scope.showAddOn = false;

    $scope.BookingOpenAfter = infoData.Settings.BookingOpenAfter;

    if ($scope.Language.indexOf('bg') > -1) {
        $translate.use('bg')
    }
    else if ($scope.Language.indexOf('cat') > -1 || $scope.Language.indexOf('esm') > -1) {
        $translate.use('es')
    }else if ($scope.Language.indexOf('pl') > -1) {
        $translate.use('pl')
    }else if ($scope.Language.indexOf('pt') > -1) {
        $translate.use('pt')
    }else if ($scope.Language.indexOf('it') > -1) {
        $translate.use('it')
    }else if ($scope.Language.indexOf('ro') > -1) {
        $translate.use('ro')
    }
    else {
        $translate.use('en')
    }

    if (infoData.Country.indexOf('enu') > -1 || infoData.Country.indexOf('ius') > -1) {
        $scope.usTime = true;
        $scope.dateFormat = 'MM.DD.YYYY';
        $scope.timeFormat = 'hh:mm a'; // used when parsing times from the backend
        $scope.timePrintFormat = 'hh:mm a';
        $scope.dateTimeFormat = 'MM-DD-YYYY hh:mm a';
    }
    else {
        $scope.usTime = false;
        $scope.dateFormat = 'DD.MM.YYYY';
        $scope.timeFormat = 'HH:mm'; // used when parsing times from the backend
        $scope.timePrintFormat = 'HH:mm [h]';
        $scope.dateTimeFormat = 'DD.MM.YYYY HH:mm [h]';
    }

    $scope.getWaiver = function(){
        var waiverHref = window.location.origin + '/waiver/embedregistration?GymID=' + params.GymID + '&NameSpace=' + params.NameSpace + '&KioskRedirect=true';
        window.location.replace(waiverHref);
    }

    $scope.scrollIframe = function(){
        document.getElementById('iframe').contentWindow.scrollTo(0,9999);
    }

    var plusClickTimer = 0;
    var plusClicked = false;

    $scope.plus = function (item) {
        item.Quantity++;
        $('.sessions-list .item.expanded').removeClass('loaded');

        if (!plusClicked) {
            plusClickTimer = setTimeout(function() {$scope.calculatePrice(item)}, 2000);
            plusClicked = true;
        }else{
            clearTimeout (plusClickTimer);
            plusClickTimer = setTimeout(function() {$scope.calculatePrice(item)}, 2000);
        }
    };
    $scope.minus = function (item) {
        if (item.Quantity != 1) {
            item.Quantity--;
        }
        $('.sessions-list .item.expanded').removeClass('loaded');

        if (!plusClicked) {
            plusClickTimer = setTimeout(function() {$scope.calculatePrice(item)}, 2000);
            plusClicked = true;
        }else{
            clearTimeout (plusClickTimer);
            plusClickTimer = setTimeout(function() {$scope.calculatePrice(item)}, 2000);
        }
    };

    $scope.calculatePrice = function (item) {
        $('.sessions-list .item.expanded').removeClass('loaded');
        // $('.sessions-list .item.expanded .actions .field-wrap .item-quantity')[0].disabled = true;
        item['PriceTotal'] = item.Quantity * item.PriceWithoutTax;
        item['PriceTotalWithTax'] = item.Quantity * item.Price1;

        $scope.selectedIndex = -1;
        $scope.ready = false;

        var now = new Date();

        setTimeout(function() {
            $scope.checkConflict(now);
        }, 500);
    }

    if (infoData.Country.indexOf('enu') > -1 || infoData.Country.indexOf('ius') > -1) {
        $scope.usTime = true;
        $scope.dateFormat = 'MM.DD.YYYY';
        $scope.timeFormat = 'hh:mm a'; // used when parsing times from the backend
        $scope.timePrintFormat = 'hh:mm a';
        $scope.dateTimeFormat = 'MM-DD-YYYY hh:mm a';
    }
    else {
        $scope.usTime = false;
        $scope.dateFormat = 'DD.MM.YYYY';
        $scope.timeFormat = 'HH:mm'; // used when parsing times from the backend
        $scope.timePrintFormat = 'HH:mm [h]';
        $scope.dateTimeFormat = 'DD.MM.YYYY HH:mm [h]';
    }


    $(document).on('keypress', '.item-quantity', function (e) {
        if (e.keyCode == 45) e.preventDefault();
    });

    $scope.getTotal = function () {
        $scope.orderInfo.TotalPriceWithoutTax = 0;

        for (var i = 0; i < $scope.booked.length; i++) {
            if ($scope.booked[i].Discount != undefined && $scope.booked[i].Discount > 0) {
                $scope.booked[i].PriceWithoutTax = $scope.booked[i].PriceWithoutTax - ($scope.booked[i].PriceWithoutTax / 100 * $scope.booked[i].Discount);
            }
            $scope.orderInfo.TotalPriceWithoutTax += $scope.booked[i].people * $scope.booked[i].PriceWithoutTax;
        }
        $scope.orderInfo.TotalPriceWithoutTax += $scope.orderInfo.addonsSum;
    };

    $scope.getTotalWithTax = function () {
        $scope.orderInfo.TotalPrice = 0;

        for (var i = 0; i < $scope.booked.length; i++) {
            if ($scope.booked[i].Discount != undefined && $scope.booked[i].Discount > 0) {
                $scope.booked[i].TotalPrice = $scope.booked[i].TotalPrice - ($scope.booked[i].TotalPrice / 100 * $scope.booked[i].Discount);
            }
            $scope.orderInfo.TotalPrice += $scope.booked[i].people * $scope.booked[i].TotalPrice;
        }
        $scope.orderInfo.TotalPrice += $scope.orderInfo.addonsSumWT;
        $scope.orderInfo.TotalPriceWT = $scope.orderInfo.TotalPrice;
    };

    getServicesAndProducts.async().then(function (d) {
        $scope.visits = d.SingleVisitsMain;
        $scope.visits = $scope.visits.concat(d.SingleVisitsSub);
        $scope.addOns = d.SingleVisitsAddons;
        console.log(d);

        for (var i = 0; i < $scope.visits.length; i++) {
            var visitHours = [];

            if ($scope.visits[i].PriceWithoutTax == 0 || $scope.visits[i].PriceWithoutTax == null)
                $scope.visits[i].PriceWithoutTax = $scope.visits[i].TotalPrice;


            var vHours = $scope.visits[i].OnlineBookingHours;

            var today = new Date();
            var d = new Date(2011, 11, 11);

            $.each(vHours, function (index, value) {
                var self = $(this);
                var hours = [];

                $.each(self[0].Hours, function (index, value) {
                    var innerSelf = $(this);
                    var newDateObj = moment(d).add(innerSelf[0].Time.TotalMinutes, 'm').format('HH:mm');

                    hours.push(newDateObj);
                });

                var oned = { day: self[0].DayOfWeek, hours: [hours] };

                visitHours.push(oned);

            });

            $scope.visits[i]['visitRealHours'] = visitHours;
            $scope.visits[i]['Quantity'] = 1;
            $scope.visits[i]['PriceTotal'] = $scope.visits[i].PriceWithoutTax;
        }

        for (var i = 0; i < $scope.addOns.length; i++) {
            $scope.addOns[i]['Quantity'] = 0;
        }
    });

    $scope.changeStep = function (n) {

        if (n == 2 && $scope.addOns.length > 0 && $scope.showAddOn == false) {
            $scope.showAddOn = true;
        } else {
            $scope.currentStep = n;
        }

        if (n == 2) {
            $('.iframe-wrapper').html("<iframe id='iframe' src='" + $scope.terms + "' style=' width: 100%; height: 700px; overflow: hidden;' scrolling='auto'></iframe>");
        }

        if ( n == 3 || n == 4 || n == 5) {
            $('.neworder-wrapper').addClass('hide-cart');
        }else{
            $('.neworder-wrapper.hide-cart').removeClass('hide-cart');
        }
    }

    $scope.changeStepY = function () {
        console.log($scope.orderInfo);
    }

    $scope.nextStep = function () {

        if ($scope.currentStep == 3) {

        } else if ($scope.currentStep == 2) {
            if (!$scope.formRegister.$invalid) {
                $scope.sendData()
            }
        } else if ($scope.currentStep == 1) {
            if ($scope.addOns.length > 0 && $scope.showAddOn == false) {
                $scope.showAddOn = true;
            } else {
                $scope.currentStep = $scope.currentStep + 1;
            }
        } else {
            $scope.currentStep = $scope.currentStep + 1;
        }
        
        if ($scope.currentStep == 2) {
            $('.iframe-wrapper').html("<iframe id='iframe' src='" + $scope.terms + "' style=' width: 100%; height: 700px; overflow: hidden;' scrolling='auto'></iframe>");
        }

        if ( $scope.currentStep == 3 || $scope.currentStep == 4 ) {
            $('.neworder-wrapper').addClass('hide-cart');
        }else{
            $('.neworder-wrapper.hide-cart').removeClass('hide-cart');
        }
    }

    $(document).on('click', '.sessions-list .item-header', function () {
        var item = $(this).parent('.item');
        $scope.ready = false;
        $scope.showAddOn = false;
        $scope.visit = false;

        if (!item.is('.expanded')) {
            item.addClass('loading');
            $scope.getVisitHours(item.data('itemid'));
            $scope.selectedIndex = -1;
        } else {
            item.removeClass('expanded loaded');
        }
    })

    $scope.getVisitHours = function (visitID) {

        $scope.orderInfo.id = visitID;
        var visitResult = $.grep($scope.visits, function (e) { return e.VisitDefinitionID == visitID; });
        $scope.visit = visitResult[0];

        var now = new Date();
        // $scope.minBookableTime = moment().add($scope.BookingOpenAfter, 'hours');
        $scope.minBookableTime = moment();
        var numberDay = moment(now).format('e');

        if (visitResult.length > 0 && visitResult != undefined) {
            var ree = $.grep(visitResult[0].visitRealHours, function (e) { return e.day == numberDay; });
            if (ree != undefined && ree.length > 0) {
                var hours = ree[0].hours[0];
                $scope.realHours = [];
                for (i = 0; i < ree[0].hours[0].length; i++) {

                    var justDate = moment(now).startOf('day');
                    var justTime = moment(ree[0].hours[0][i], $scope.timeFormat);
                    var dateTime = moment(justDate).add(justTime.hours(), 'hours').add(justTime.minutes(), 'minutes');
                    if (moment(dateTime).isAfter($scope.minBookableTime)) {
                        $scope.realHours.push(ree[0].hours[0][i]);
                    }
                }

                if ($scope.realHours.length < 1) {
                    setTimeout(function () {
                        $('.sessions-list .item[data-itemid="' + visitID + '"]').addClass('disabled').removeClass('loading');
                    }, 500);
                } else {
                    $('.sessions-list .item[data-itemid="' + visitID + '"]').removeClass('loading').addClass('expanded').siblings().removeClass('expanded loaded');
                }

                //setup before functions
                var typingPeople;
                var $inputPeople = $('.sessions-list .item.expanded .actions .field-wrap .item-quantity');

                //on keyup, start the countdown
                $inputPeople.on('keyup', function () {
                  clearTimeout(typingPeople);
                  typingPeople = setTimeout(function() {$scope.calculatePrice($scope.visit)}, 2000);
                });

                //on keydown, clear the countdown 
                $inputPeople.on('keydown', function () {
                  clearTimeout(typingPeople);
                  $('.sessions-list .item.expanded').removeClass('loaded');
                });
                $scope.checkConflict(now);
            }
        }
    }

    $scope.checkConflict = function (b) {
        var item = $('.sessions-list .item.expanded');
        var people = item.find('.item-quantity').val();
        $scope.orderInfo.People = people;

        $scope.ccData = {};
        $scope.loading = true;

        $scope.ccData.VisitId = item.data('itemid')
        $scope.ccData.StartDate = b;
        if (people < 1)
            $scope.ccData.People = 1;
        else
            $scope.ccData.People = people;
        $scope.ccData.NameSpace = $scope.infoData.NameSpace;
        $scope.ccData.GymID = $scope.infoData.GymID;
        $scope.ccData.IsBirthday = false;

        if ($scope.realHours) {
            $scope.ccData.StartDate = $scope.realHours.map(function (h) {
                var justDate = moment($scope.date).startOf('day');
                var justTime = moment(h, $scope.timeFormat);
                var dateTime = moment(justDate).add(justTime.hours(), 'hours').add(justTime.minutes(), 'minutes');
                var isDstChangeDay = moment(justDate, "DD.MM.YYYY").isDST() !== moment(justDate, "DD.MM.YYYY").add(1, "day").isDST();
                if (isDstChangeDay)
                    dateTime = dateTime.add(1, 'hours');

                return dateTime.toISOString();
            });

            Backend.checkConflictAsync($scope.ccData).then(function success(results) {
                $scope.curHours = _.map(results.data, function (hourData) {
                    return {
                        isConflict: hourData.MaxPeople > 0,
                        areas: hourData.Areas,
                        value: moment(hourData.StartDate).format($scope.timeFormat),
                        slotsleft: hourData.SlotsLeft
                    };
                });

                $scope.loading = false;
                plusClicked = false;
                $('.sessions-list .item.expanded').addClass('loaded');
                // $('.sessions-list .item.expanded .actions .field-wrap .item-quantity')[0].disabled = false;
                $scope.compare();
            });

        }
    };

    $scope.addToCart = function (item) {
        // $scope.showAddOn = true;
        $scope.calculatePrice(item);

        var date = new Date();
        var justDate = moment($scope.date).startOf('day');
        var justTime = moment($scope.orderInfo.Time, $scope.timeFormat);
        var dateTime = moment(justDate).add(justTime.hours(), 'hours').add(justTime.minutes(), 'minutes');
        var isDstChangeDay = moment(justDate, "DD.MM.YYYY").isDST() !== moment(justDate, "DD.MM.YYYY").add(1, "day").isDST();
        if (isDstChangeDay){
            dateTime = dateTime.add(1, 'hours');
        }
        $scope.orderInfo.Date = moment(dateTime);
        $scope.orderInfo.StartDate = moment(dateTime);
        $scope.orderInfo.People = $('.sessions-list .item.expanded .item-quantity').val();
        $scope.orderInfo.PriceTotal = item.PriceTotal;
        $scope.orderInfo.PriceTotalWithTax = item.PriceTotalWithTax;
        $scope.selectedIndex = -1;
        $scope.bookVisit($scope.orderInfo);

        $scope.ready = false;

        Swal.fire({
            type: 'success',
            title: 'Product added to cart.',
            showConfirmButton: false,
            timer: 1500
        })
    }

    $scope.bookVisit = function (item) {
        var dateLocal = moment(new Date(item.Date)).format($scope.dateTimeFormat);
        $scope.bookedItem = { VisitID: item.id, VisitName: $scope.visit.VisitName, UniqueID: item.id + dateLocal, people: item.People, Date: item.Date, Price: $scope.visit.PriceCurrent, TotalPrice: $scope.visit.PriceCurrent, PriceWithoutTax: $scope.visit.PriceWithoutTax, Duration: $scope.visit.Duration, DateLocal: dateLocal, DateHour: item.Time, TaxIDs: $scope.visit.TaxIDs, Tax: $scope.visit.TaxPercent, OnlineBookingPictureLink: $scope.visit.OnlineBookingPictureLink, Description: $scope.visit.Description, PriceTotal: item.PriceTotal, PriceTotalWithTax: item.PriceTotalWithTax }

        var result = $.grep($scope.booked, function (e) { return e.UniqueID == $scope.bookedItem.UniqueID; });

        if (result.length > 0) {
            $scope.removeByAttr($scope.booked, 'UniqueID', $scope.bookedItem.UniqueID)
        }
        $scope.booked.push($scope.bookedItem);

        toSchedules();
    }

    var n = 0;
    var toSchedules = function (bookInfo) {
        $scope.orderInfo.Schedules = [];
        $scope.bookedInfo = $scope.booked.map(function (bookedItem) {
            n++;

            var sessionID = bookedItem.VisitID + bookedItem.VisitName + n;

            return {
                VisitID: bookedItem.VisitID,
                VisitName: bookedItem.VisitName,
                PeopleAttending: bookedItem.people,
                Date: moment(bookedItem.Date).toISOString(),
                Price: bookedItem.TotalPrice,
                PriceWithoutTax: bookedItem.PriceWithoutTax,
                PriceTotal: bookedItem.PriceTotal,
                PriceTotalWithTax: bookedItem.PriceTotalWithTax,
                Duration: bookedItem.Duration,
                DateLocal: bookedItem.DateLocal,
                DateHour: bookedItem.DateHour,
                TaxIDs: bookedItem.TaxIDs,
                SessionID: sessionID,
                UniqueID: bookedItem.VisitID + bookedItem.DateLocal
            };
        });

        $scope.orderInfo.Schedules = $scope.bookedInfo;
        $scope.getTotal();
        $scope.getTotalWithTax();

        if ($scope.orderInfo.Schedules.length > 0) {
            $scope.showCart = true;
        }
    };

    $scope.compare = function ($index) {
        var itemPeople = $('.sessions-list .item.expanded .item-quantity').val();
        if ($index == undefined)
            return;
        $scope.selectedIndex = $index;

        var SelectedItem = $scope.curHours[$index];
        $scope.visitLimit = SelectedItem.slotsleft
        if (SelectedItem != undefined) {
            if (SelectedItem.isConflict == true) {
                $scope.ready = false;
            } else {
                $scope.orderInfo.Time = $scope.realHours[$index];
                $scope.hours = $scope.realHours;
                $scope.orderInfo.Areas = $scope.curHours[$index].areas;

                $scope.maxPeople = $scope.orderInfo.Areas[0].MaxPeople;

                if (itemPeople > 0 && $scope.orderInfo.Time != '' && itemPeople <= $scope.maxPeople) {
                    $scope.ready = true;
                }
                else {
                    Swal.fire({
                        type: 'warning',
                        title: "There are not enough free slots for this hour!"
                    })
                    $scope.ready = false;
                }
            }
        }

    }

    $scope.sendData = function (t) {
        $scope.error = false;
        var data = {
            Email: $scope.orderInfo.Email,
            GymID: params.GymID,
            Namespace: params.NameSpace
        }

        $http.post('/Waiver/HasWaiver', data)
            .then(function successCallback(response) {
                console.log(response);

                if (response.data > 0) {
                    $scope.orderInfo.ClientID = parseInt(response.data);
                    $scope.error = false;
                    $scope.changeStep(3);
                } else {
                    $scope.error = true;
                    $scope.formRegister.$invalid = true;

                    Swal.fire({
                        type: 'warning',
                        title: "You don't have waiver, please before continue sign a waiver and then you can finish your order!"
                    })
                }
            }, function (d) {

            });

        console.log($scope.orderInfo);
    };

    $scope.removeByAttr = function (arr, attr, value) {
        var i = arr.length;
        while (i--) {
            if (arr[i]
                && arr[i].hasOwnProperty(attr)
                && (arguments.length > 2 && arr[i][attr] === value)) {
                arr.splice(i, 1);
            }
        }
        return arr;
    }

    $scope.removeVisit = function (visit) {
        $scope.removeByAttr($scope.booked, 'UniqueID', visit.UniqueID)
        $scope.removeByAttr($scope.orderInfo.Schedules, 'UniqueID', visit.UniqueID)

        $scope.getTotal();
        $scope.getTotalWithTax();

        // $scope.finalSchedule = $scope.orderInfo.Schedules;
        // $scope.lastV = $scope.finalSchedule[$scope.finalSchedule.length - 1];
        // $scope.lastId = $scope.lastV.VisitID;
        // $scope.paymentPageText = infoData.Settings.PaymentPageText;
        // $scope.orderInfo.TotalPriceWOTax = $scope.orderInfo.TotalPriceWithoutTax + $scope.orderInfo.addonsSum;
        // $scope.orderInfo.Tax = $scope.orderInfo.TotalPrice - $scope.orderInfo.TotalPriceWithoutTax;

        if ($scope.orderInfo.Schedules.length == 0) {
            $scope.showCart = false;
            $scope.changeStep(1);
            $scope.showAddOn = false;
            $('body').removeClass('show-cart');
        }
    };

    $scope.plusAddon = function (item) {
        item.Quantity++;
        $scope.calculatePrice(item);
        $scope.saveAdd(item);
    };
    $scope.minusAddon = function (item) {
        if (item.Quantity != 0) {
            item.Quantity--;
            $scope.calculatePrice(item);
            $scope.saveAdd(item);
        }
    };


    $scope.saveAdd = function (i) {
        $scope.deleteAdd(i.VisitDefinitionID);
        $scope.item = i;
        $scope.item.Amount = $scope.item.Quantity;

        if ($scope.item.Amount > 0) {
            $scope.item.Total = $scope.item.Amount * $scope.item.PriceWithoutTax;
            $scope.item.TotalWT = $scope.item.Amount * $scope.item.TotalPrice;

            dataShare.addAddon(i);
            updateAddonsSum();
        }
    }

    $scope.deleteAdd = function (k) {
        var key;
        for (key in $scope.adds) {
            if ($scope.adds[key].VisitDefinitionID == k)
                $scope.adds.splice(key, 1);
            // $scope.adds[key].added = false;
        }

        updateAddonsSum();
    };

    var updateAddonsSum = function () {
        $scope.addonsSum = 0;
        $scope.addonsSumWT = 0;
        $scope.Price = 0;
        var i;
        for (i = 0; i < $scope.adds.length; i++) {
            $scope.addonsSum += $scope.adds[i].PriceWithoutTax * $scope.adds[i].Amount;
            $scope.addonsSumWT += $scope.adds[i].TotalPrice * $scope.adds[i].Amount;
        }

        if ($scope.addonsSum > 0) {
            $scope.full = true;
        } else {
            $scope.full = false;
        }

        $scope.Price = $scope.orderInfo.TotalPrice + $scope.addonsSum;

        $scope.orderInfo.addonsSum = $scope.addonsSum;
        $scope.orderInfo.addonsSumWT = $scope.addonsSumWT;
        $scope.orderInfo.Addons = data.addons;

        console.log($scope.orderInfo);

        $scope.getTotal();
        $scope.getTotalWithTax();
    };
    updateAddonsSum();

    $scope.sendOrderInfo = function (data, url) {
        $scope.sendOrderFail = false;

        var justDate = moment($scope.orderInfo.StartDate).startOf('day');

        var justTime = moment($scope.orderInfo.Time, $scope.timeFormat);
        var dateTime = moment(justDate).add(justTime.hours(), 'hours').add(justTime.minutes(), 'minutes');

        $scope.orderSent = true;
        if (data.Schedules.length > 0) {
            $scope.orderInfo.TotalPriceWithoutTax = $scope.orderInfo.TotalPriceWithoutTax;
        } else {
            $scope.orderInfo.TotalPriceWithoutTax = $scope.orderInfo.TotalPrice;
        }

        if ($scope.orderInfo.DiscountPromoCode > 0) {
            $scope.orderInfo.TotalPriceWithoutTax = $scope.orderInfo.TotalPriceWithoutTax - ($scope.orderInfo.TotalPriceWithoutTax / 100 * $scope.orderInfo.DiscountPromoCode);
            // $scope.orderInfo.TotalPrice = $scope.orderInfo.TotalPrice - ($scope.orderInfo.TotalPrice / 100 * $scope.orderInfo.DiscountPromoCode);
            // $scope.orderInfo.TotalPriceWT = $scope.orderInfo.TotalPriceWT - ($scope.orderInfo.TotalPriceWT / 100 * $scope.orderInfo.DiscountPromoCode);
        }

        var isDstChangeDay = moment(justDate, "DD.MM.YYYY").isDST() !== moment(justDate, "DD.MM.YYYY").add(1, "day").isDST();
        if (isDstChangeDay)
            dateTime = dateTime.add(-1, 'hours');

        $scope.orderInfo.StartDate = moment(dateTime).format($scope.dateTimeFormat).toString();
        $scope.orderInfo.KioskMode = true;
        $scope.orderInfo.PaymentType = 11;

        if (data.deposit === false && $scope.onlyEarnest !== true)
            data.Earnest = 0;
        else
            data.Earnest = infoData.Settings.Earnest;

        $http({
            method: 'POST',
            url: url,
            data: data
        }).then(function (d) {
            if (d.data === '' || d.data.toString().indexOf('Error') !== -1) {
                $scope.fail = d.data;
                $scope.changeStep(5);
            } else if (typeof d.data === 'string' || d.data instanceof String) {
                if ($scope.orderInfo.PaymentType == "4" || $scope.orderInfo.PaymentType == "6") {
                    $('.payment-status .error-msg').addClass('show').append('<p>' + d.data + '</p>');
                    $scope.orderSent = false;
                }
                else {
                    $window.location.href = d.data;
                }
            }
            else {
                $scope.backInfo = d.data;
                $scope.backInfo.Schedules = d.data.Schedules;

                if ($scope.backInfo.Schedules && $scope.backInfo.Schedules.length > 0)
                    $scope.backInfo.Tax = $scope.backInfo.TotalPrice - $scope.backInfo.TotalPriceWithoutTax;
                else {
                    $scope.backInfo.Tax = $scope.backInfo.TotalPriceWithProducts - $scope.backInfo.TotalPriceWithoutTax;
                }

                for (var key in $scope.backInfo.Schedules) {
                    $scope.backInfo.Schedules[key].DateEnd = moment($scope.backInfo.Schedules[key].DateEnd).format($scope.dateTimeFormat);
                    $scope.backInfo.Schedules[key].DateStart = moment($scope.backInfo.Schedules[key].Date).format($scope.dateTimeFormat);
                }
                $scope.backInfo.DateStart = moment(d.data.DateStart).format($scope.dateTimeFormat);
                $scope.backInfo.DateEnd = moment(d.data.DateEnd).format($scope.dateTimeFormat);

                /*var paypal = {};
                paypal.OrderID = $scope.backInfo.OrderID = d.data.OrderID;
                if (($scope.backInfo.Schedules.length == 0) && $scope.onlyEarnest == true || $scope.orderInfo.deposit) {
                    paypal.TotalPrice = infoData.Settings.Earnest;
                } else{
                    paypal.TotalPrice = d.data.TotalPrice;
                }
                paypal.NameSpace = params.NameSpace;
                paypal.GymID = params.GymID;
                paypal.TotalPriceWithoutTax = d.data.TotalPriceWithoutTax;*/

                /*if ($scope.orderInfo.PaymentType == 1) {
                    $scope.sendPaypal(paypal);
                } else*/

                Swal.fire({
                    type: 'success',
                    title: 'Payment finished with success.',
                    onAfterClose: (function () {
                        setTimeout(function() {
                            $scope.reload();
                        }, 2000);
                    })
                })

                $scope.changeStep(4);

                if ($scope.infoData.Local != true) {
                    printReceipt($scope.backInfo.OrderID);
                    // $scope.paying = false;
                } else {

                }

                // $scope.changeStep(4);
            }
        }, function () {
            $scope.sendOrderFail = true;
            $scope.orderSent = false;
            $scope.loading = false;
            // var url = $scope.params + '#/booking-failed/0';
            // $window.location.href = url;
        });

    };

    var transactionReference = 304;

    $scope.sendOrder = function () {

        console.log($scope.orderInfo);

        // $scope.sendOrderInfo($scope.orderInfo, '/onlinebooking/bookvisits/');

        if ($scope.infoData.Local != true) {

            Swal.fire({
                type: 'warning',
                title: 'Please',
                text: 'Follow the instruction on the terminal!'
            });

            $scope.paying = true;
            var payPromise = pay($scope.orderInfo.TotalPriceWT);
            payPromise.then(
                function (payObj) {
                    // alert('Then Send Order Info');
                    $scope.sendOrderInfo($scope.orderInfo, '/onlinebooking/bookvisits/');
                    //  Show Payment success:
                }, function (error) {
                    // alert('Error' + error);

                    Swal.fire({
                        type: 'error',
                        title: "Payment error. Please try again.",
                        onAfterClose: (function () {
                            $scope.reload();
                            
                            $scope.paying = false;
                        })
                    })

                }
            );
        } else {
            $scope.sendOrderInfo($scope.orderInfo, '/onlinebooking/bookvisits/');
        }
    }

    $scope.MBirdSdkConnected = function () {
        if (MBirdSdk.isConnected()) {
            var promise = MBirdSdk.Peripherals.Status();
            promise.then(function (value) {
                var isPaymentAvailable = JSON.stringify(value.IsPaymentAvailable);

                if (isPaymentAvailable == 'true') {
                    $scope.isPaymentAvailable = true;
                } else {
                    $scope.isPaymentAvailable = false;
                }
            });
        }
    }



    $(window).on('load', function(){
        $scope.MBirdSdkConnected();
    })

    // Start the pay process:
    function pay(totalCost) {
        var defer = $q.defer();
        setTimeout(function () {
            if (MBirdSdk.isConnected()) {
                var promise = MBirdSdk.Peripherals.Status();
                promise.then(function (value) {
                    var isPaymentAvailable = JSON.stringify(value.IsPaymentAvailable);

                    if (isPaymentAvailable == 'true') {
                        var totalCostCent = parseInt(totalCost * 100);
                        var payObj = MBirdSdk.Payment.Pay(totalCostCent, transactionReference);

                        // Resolve:
                        defer.resolve(payObj);

                    } else {
                        defer.reject("Payment hardware not available.");
                    }
                });
            } else {
                defer.reject("MBirdSdk is not connected");
            }
        }, 100)// Use TimeOut because of the sync request
        return defer.promise;
    }
    // Print Order:
    function printReceipt(orderId) {
        var defer = $q.defer();
        setTimeout(function () {
            // Print Receipt:     
            var promise = MBirdSdk.Peripherals.Status();
            promise.then(function (value) {
                var isPrinterAvailable = JSON.stringify(value.IsPrinterAvailable);

                if (isPrinterAvailable == 'true') {

                    var printContent = getReceiptContent($scope.orderInfo.TotalPriceWT, orderId, $scope.CompanyName);

                    var printObj = MBirdSdk.Printer.TagContent(printContent);
                    // var printObj = MBirdSdk.Printer.TagContent(printContent);
                    defer.resolve(printObj);

                    setTimeout(function () {
                        $scope.reload();
                    }, 2000);
                } else {
                    defer.reject("Printer not available.");
                }
            });
        }, 100)// Use TimeOut because of the sync request
        return defer.promise;
    }

    function pad(n){ 
        return ("0" + n).slice(-2); 
    }

    // Returns a string formated on multiple lines.
    function getReceiptContent(totalCost,
        transactionReference,
        shopName) {

        var products = $scope.orderInfo.Schedules;
        var addOns = $scope.orderInfo.Addons;
        var current_datetime = new Date()
        var dateFor = current_datetime.getFullYear() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getDate() + " " + current_datetime.getHours() + ":" + current_datetime.getMinutes() + ":" + pad(current_datetime.getSeconds());
        var totalLineLength = 42;
        var printContent = "";

        if (shopName) {
            printContent += getSpaces((totalLineLength - shopName.length) / 2) + shopName + "\r\n\r\n\r\n";
        }

        printContent += getSpaces((totalLineLength - ("RECEIPT FISCAL " + transactionReference).length) / 2) + "RECEIPT FISCAL " + transactionReference + "\r\n\r\n";
        printContent += "Client: " + $scope.orderInfo.FirstName + ' ' + $scope.orderInfo.LastName + "\r\n";;
        printContent += "Email: " + $scope.orderInfo.Email + "\r\n";;
        printContent += "Phone: " + $scope.orderInfo.EmergencyPhone + "\r\n";;
        printContent += "\r\n\r\n";
        printContent += "Items: \r\n";
        for (var i = 0; i < products.length; i++) {
            var productName = products[i].PeopleAttending + " x " + products[i].VisitName.substr(0, 17).toUpperCase();
            var productPrice = products[i].PriceTotal.toFixed(2) + " " + $scope.Currency;
            if ( $scope.ShowFullPrices == true ) {
                productPrice = products[i].PriceTotalWithTax.toFixed(2) + $scope.Currency;
            }
            var dif = totalLineLength - (productName + productPrice).length;

            printContent += productName;
            printContent += getSpaces(dif);
            printContent += productPrice + "\r\n";
        }

        if ( addOns.length > 0 ) {
            for (var i = 0; i < addOns.length; i++) {
                var productName = addOns[i].Amount + " x " + addOns[i].VisitName.substr(0, 25).toUpperCase();
                var productPrice = addOns[i].Total.toFixed(2) + " " + $scope.Currency;
                if ( $scope.ShowFullPrices == true ) {
                    productPrice = addOns[i].TotalWT.toFixed(2) + " " + $scope.Currency;
                }
                var dif = totalLineLength - (productName + productPrice).length;

                printContent += productName;
                printContent += getSpaces(dif);
                printContent += productPrice + "\r\n";
            }
        }

        // printContent += "\r\n \r\n";
        // printContent += "\r\n \r\n";
        // printContent += "<@PaymentCustomerReceipt>";
        // printContent += "\r\n \r\n";
        // printContent += "\r\n \r\n";
        // printContent += "<@PaymentMerchantReceipt>";
        // printContent += "\r\n \r\n";
        printContent += "\r\n \r\n";

        // printContent += "\r\n";
        var dif = totalLineLength - ("TOTAL Without Taxes".length + $scope.orderInfo.TotalPriceWithoutTax.toFixed(2).length + $scope.Currency.length);
        printContent += "TOTAL Without Taxes" + getSpaces(dif) + $scope.orderInfo.TotalPriceWithoutTax.toFixed(2) + $scope.Currency + "\r\n";

        printContent += "\r\n";
        var dif = totalLineLength - ("TOTAL".length + totalCost.toFixed(2).length + $scope.Currency.length);
        printContent += "TOTAL" + getSpaces(dif) + totalCost.toFixed(2) + $scope.Currency + "\r\n";
        printContent += "\r\n";
        printContent += "<@PaymentCustomerReceipt>";
        printContent += "<@PaymentMerchantReceipt>";
        // printContent += getSpaces((totalLineLength - dateFor.length) / 2) + dateFor;
        printContent += "\r\n\r\n\r\n";
        printContent += "<@PartialCut>";

        return printContent;
    }

    function getSpaces(num) {
        var sp = "";
        for (var l = 0; l < num; l++) {
            sp += " ";
        }
        return sp;
    }

    $scope.reload = function () {
        var kioskHref = window.location.origin + '/OnlineBooking/KioskBooking?GymID=' + params.GymID + '&NameSpace=' + params.NameSpace;
        window.location.replace(kioskHref);
    }

}]);